import { RouteConfig } from 'vue-router';
const Home = () => import('./home.vue');
const HomeNew = () => import('./home_new.vue');
const Account = () => import('../account/account.vue');
const Setting = () => import('../setting/setting.vue');
const Patient = () => import('../patient/patient.vue');
const Report = () => import('../report/report.vue');
const EditCeping = () => import('./edit-ceping.vue');
const EditWen = () => import('./edit-wen.vue');
const EditCeping2 = () => import('./edit-ceping2.vue');
const EditZhuanbingScale = () => import('./zhuanbing/edit-zhuanbing-scale.vue');
const EditZhuanbingBianzheng = () => import('./zhuanbing/edit-zhuanbing-bianzheng.vue');
const EditZhuanbingZhenghou = () => import('./zhuanbing/edit-zhuanbing-zhenghou.vue');
import AccountRouterChildren from '../account/account.router';
import SettingRouterChildren from '../setting/setting.router';
import PatientRouterChildren from '../patient/patient.router';
import ReportRouterChildren from '../report/report.router';
const routers: RouteConfig[] = [
    {
        path: 'home',
        component: HomeNew,
    },
    {
        path: 'edit-ceping',
        component: EditCeping,
    },
    {
        path: 'edit-wen',
        component: EditWen,
    },
    {
        path: 'edit-ceping2',
        component: EditCeping2,
    },
    {
        path: 'edit-zhuanbing-scale',
        component: EditZhuanbingScale,
    },
    {
        path: 'edit-zhuanbing-bianzheng',
        component: EditZhuanbingBianzheng,
    },
    {
        path: 'edit-zhuanbing-zhenghou',
        component: EditZhuanbingZhenghou,
    },
    {
        path: 'account',
        component: Account,
        children: AccountRouterChildren
    },
    {
        path: 'setting',
        component: Setting,
        children: SettingRouterChildren
    },
    {
        path: 'patient',
        component: Patient,
        children: PatientRouterChildren
    },
    {
        path: 'report',
        component: Report,
        children: ReportRouterChildren
    },
];
export default routers;



